/*
 * GST invoice collection for the Oblivion cart — behaviour for
 * snippets/oblivion-gst.liquid.   v1.0.0
 *
 *  - stores everything as Shopify cart attributes through POST /cart/update.js,
 *    the store's own cart API; it never builds a second cart system
 *  - checks the GSTIN format and the standard check character. That is a FORMAT
 *    check, not verification: no GST verification service is connected, and the
 *    wording in the UI never claims otherwise
 *  - calculates no tax and touches no price
 *  - "GST Invoice requested" only appears once the attributes are really saved
 *  - when GST is on but incomplete it stops that one checkout click and shows the
 *    errors; in every other case the GoKwik checkout button behaves exactly as before
 *
 * ES5, no dependencies, safe to include twice.
 */
(function () {
  'use strict';
  if (window.OblivionGST && window.OblivionGST.version) { window.OblivionGST.init(); return; }

  var DEFAULTS = {
    enabled: true,
    required_fields: ['business_name', 'gstin', 'billing_address', 'state', 'pincode'],
    validate_gstin_format: true,
    validate_gstin_checksum: true,
    allow_billing_same_as_shipping: true,
    save_as_cart_attributes: true,
    require_confirmation_before_checkout: true
  };

  var MESSAGES = {
    business_name: 'Please enter your business name.',
    gstin_empty: 'Please enter your GSTIN.',
    gstin_length: 'Please enter a valid 15-character GSTIN.',
    gstin_format: 'Please enter a valid GSTIN.',
    billing_address: 'Please enter your billing address.',
    state: 'Please select your state.',
    pincode: 'Please enter a valid 6-digit pincode.',
    save_failed: 'Your GST details could not be saved. Please try again.',
    network: 'We could not reach the cart. Check your connection and try again.',
    saved: 'GST details saved successfully.',
    removed: 'GST invoice turned off.',
    incomplete: 'Please complete and save your GST details before checkout.'
  };

  /* GST state codes, used to fill the state field and to check it against the GSTIN */
  var STATES = {
    '01': 'Jammu and Kashmir', '02': 'Himachal Pradesh', '03': 'Punjab', '04': 'Chandigarh',
    '05': 'Uttarakhand', '06': 'Haryana', '07': 'Delhi', '08': 'Rajasthan', '09': 'Uttar Pradesh',
    '10': 'Bihar', '11': 'Sikkim', '12': 'Arunachal Pradesh', '13': 'Nagaland', '14': 'Manipur',
    '15': 'Mizoram', '16': 'Tripura', '17': 'Meghalaya', '18': 'Assam', '19': 'West Bengal',
    '20': 'Jharkhand', '21': 'Odisha', '22': 'Chhattisgarh', '23': 'Madhya Pradesh',
    '24': 'Gujarat', '26': 'Dadra and Nagar Haveli and Daman and Diu', '27': 'Maharashtra',
    '29': 'Karnataka', '30': 'Goa', '31': 'Lakshadweep', '32': 'Kerala', '33': 'Tamil Nadu',
    '34': 'Puducherry', '35': 'Andaman and Nicobar Islands', '36': 'Telangana',
    '37': 'Andhra Pradesh', '38': 'Ladakh', '97': 'Other Territory'
  };
  var GSTIN_RE = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z][0-9A-Z]Z[0-9A-Z]$/;
  var CODE_CHARS = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  var FIELDS = ['business_name', 'gstin', 'billing_address', 'state', 'pincode'];
  var ADDRESS_FIELDS = ['billing_address', 'state', 'pincode'];

  var config = null;
  var opened = false;

  /* ---------------- helpers ---------------- */
  function qsa(sel, scope) { return Array.prototype.slice.call((scope || document).querySelectorAll(sel)); }
  function cards() {
    return qsa('[data-obgst]').filter(function (el) {
      return !(el.closest && el.closest('template, #quick-add-modal-content'));
    });
  }
  /* one card owns the data: the first one that is actually on screen */
  function active() {
    var list = cards().filter(function (el) { return el.offsetParent !== null || el.getClientRects().length; });
    return list[0] || cards()[0] || null;
  }
  function routeRoot() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function readConfig() {
    if (config) return config;
    config = {};
    for (var key in DEFAULTS) { if (DEFAULTS.hasOwnProperty(key)) config[key] = DEFAULTS[key]; }
    var el = document.querySelector('[data-obgst-config]');
    if (el) {
      try {
        var raw = JSON.parse(el.textContent);
        for (var k in raw) { if (raw.hasOwnProperty(k) && raw[k] !== null && raw[k] !== undefined) config[k] = raw[k]; }
      } catch (e) { /* the defaults above already stand */ }
    }
    window.OBLIVION_GST_CONFIG = config;
    return config;
  }
  function field(root, name) { return root.querySelector('[data-obgst-input="' + name + '"]'); }
  function valueOf(root, name) {
    var el = field(root, name);
    if (!el) return '';
    return String(el.value == null ? '' : el.value).trim();
  }
  function sameAsShipping(root) {
    var el = root.querySelector('[data-obgst-same]');
    return !!(el && el.checked);
  }
  function requiredFields(root) {
    var wanted = readConfig().required_fields || FIELDS;
    var list = [];
    for (var i = 0; i < wanted.length; i++) {
      var name = wanted[i];
      if (FIELDS.indexOf(name) < 0) continue;
      /* the address is not asked for twice when the shopper picked the delivery address */
      if (sameAsShipping(root) && ADDRESS_FIELDS.indexOf(name) > -1) continue;
      list.push(name);
    }
    return list;
  }

  /* ---------------- GSTIN format ---------------- */
  function checkCharacter(first14) {
    var sum = 0;
    for (var i = 0; i < first14.length; i++) {
      var code = CODE_CHARS.indexOf(first14.charAt(i));
      if (code < 0) return '';
      var product = code * (i % 2 === 0 ? 1 : 2);
      sum += Math.floor(product / 36) + (product % 36);
    }
    return CODE_CHARS.charAt((36 - (sum % 36)) % 36);
  }
  /* returns '' when the format is fine, else a message key */
  function gstinProblem(raw) {
    var value = String(raw || '').toUpperCase().replace(/\s+/g, '');
    if (!value) return 'gstin_empty';
    if (value.length !== 15) return 'gstin_length';
    if (readConfig().validate_gstin_format && !GSTIN_RE.test(value)) return 'gstin_format';
    if (!STATES[value.slice(0, 2)]) return 'gstin_format';
    if (readConfig().validate_gstin_checksum && checkCharacter(value.slice(0, 14)) !== value.charAt(14)) return 'gstin_format';
    return '';
  }
  function stateFromGstin(value) { return STATES[String(value || '').slice(0, 2)] || ''; }

  /* ---------------- validation ---------------- */
  function validate(root) {
    var problems = [];
    var needed = requiredFields(root);
    for (var i = 0; i < needed.length; i++) {
      var name = needed[i];
      var value = valueOf(root, name);
      if (name === 'gstin') {
        var key = gstinProblem(value);
        if (key) problems.push({ field: 'gstin', message: MESSAGES[key] });
        continue;
      }
      if (name === 'pincode') {
        if (!/^[1-9][0-9]{5}$/.test(value)) problems.push({ field: 'pincode', message: MESSAGES.pincode });
        continue;
      }
      if (!value) problems.push({ field: name, message: MESSAGES[name] });
    }
    return problems;
  }
  function paintErrors(root, problems) {
    qsa('[data-obgst-err]', root).forEach(function (el) { el.hidden = true; el.textContent = ''; });
    qsa('[data-obgst-input]', root).forEach(function (el) { el.removeAttribute('aria-invalid'); });
    problems.forEach(function (p) {
      var err = root.querySelector('[data-obgst-err="' + p.field + '"]');
      if (err) { err.textContent = p.message; err.hidden = false; }
      var input = field(root, p.field);
      if (input) input.setAttribute('aria-invalid', 'true');
    });
    var first = problems.length ? field(root, problems[0].field) : null;
    if (first && first.focus) { try { first.focus({ preventScroll: false }); } catch (e) { first.focus(); } }
  }
  function paintGstinStatus(root) {
    var note = root.querySelector('[data-obgst-gstin-status]');
    var input = field(root, 'gstin');
    if (!note || !input) return;
    var value = input.value.trim();
    if (!value) { note.hidden = true; return; }
    var problem = gstinProblem(value);
    note.hidden = false;
    note.className = 'obgst__note ' + (problem ? 'obgst__note--bad' : 'obgst__note--ok');
    /* a format check only — never described as verified with the GST department */
    note.textContent = problem ? '✕ Please enter a valid GSTIN' : '✓ Valid GSTIN format';
  }

  /* ---------------- cart attributes ---------------- */
  function updateAttributes(attributes) {
    return fetch(routeRoot() + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attributes })
    }).then(function (res) {
      if (!res.ok) throw new Error('save_failed');
      return res.json();
    }, function () { throw new Error('network'); });
  }
  function collect(root) {
    var same = sameAsShipping(root);
    return {
      gst_invoice_required: 'true',
      gst_business_name: valueOf(root, 'business_name'),
      gstin: valueOf(root, 'gstin').toUpperCase(),
      gst_billing_address: same ? '' : valueOf(root, 'billing_address'),
      gst_state: same ? '' : valueOf(root, 'state'),
      gst_pincode: same ? '' : valueOf(root, 'pincode'),
      gst_billing_same_as_shipping: same ? 'true' : 'false'
    };
  }
  function snapshot(root) { return JSON.stringify(collect(root)); }

  /* ---------------- view ---------------- */
  function status(root, message, ok) {
    var el = root.querySelector('[data-obgst-status]');
    if (!el) return;
    if (!message) { el.hidden = true; el.textContent = ''; return; }
    el.hidden = false;
    el.className = 'obgst__status ' + (ok ? 'obgst__status--ok' : 'obgst__status--bad');
    el.textContent = (ok ? '✓ ' : '') + message;
  }
  function showSaved(root, saved) {
    root.setAttribute('data-obgst-saved', saved ? 'true' : 'false');
    var badge = root.querySelector('[data-obgst-badge]');
    var summary = root.querySelector('[data-obgst-summary]');
    var form = root.querySelector('[data-obgst-form]');
    if (badge) badge.hidden = !saved;
    if (summary) summary.hidden = !saved;
    if (form) form.hidden = saved || !wantsGst(root);
  }
  function paintSummary(root) {
    var data = collect(root);
    var set = function (key, text) {
      var el = root.querySelector('[data-obgst-sum="' + key + '"]');
      if (el) el.textContent = text;
    };
    set('business_name', data.gst_business_name);
    set('gstin', data.gstin);
    set('state', data.gst_state);
    set('address', data.gst_pincode ? data.gst_billing_address + ' — ' + data.gst_pincode : data.gst_billing_address);
    var same = data.gst_billing_same_as_shipping === 'true';
    var addrRow = root.querySelector('[data-obgst-sum-row="address"]');
    var sameRow = root.querySelector('[data-obgst-sum-row="same"]');
    if (addrRow) addrRow.hidden = same;
    if (sameRow) sameRow.hidden = !same;
  }
  function isSaved(root) { return root.getAttribute('data-obgst-saved') === 'true'; }
  function isDirty(root) { return isSaved(root) && root._obgstSnapshot !== snapshot(root); }
  function wantsGst(root) {
    var toggle = root.querySelector('[data-obgst-toggle]');
    return !!(toggle && toggle.checked);
  }

  /* ---------------- analytics: status only, never the GSTIN ---------------- */
  function track(event, detail) {
    try {
      var payload = { event: event };
      if (detail) { for (var k in detail) { if (detail.hasOwnProperty(k)) payload[k] = detail[k]; } }
      (window.dataLayer = window.dataLayer || []).push(payload);
    } catch (e) { /* analytics must never affect the cart */ }
  }

  /* ---------------- actions ---------------- */
  function save(root, btn) {
    var problems = validate(root);
    if (problems.length) {
      paintErrors(root, problems);
      status(root, problems[0].message, false);
      track('gst_invoice_validation_failed', { gst_fields: problems.map(function (p) { return p.field; }).join(',') });
      return Promise.resolve(false);
    }
    paintErrors(root, []);
    if (!readConfig().save_as_cart_attributes) return Promise.resolve(false);
    if (btn) { btn.classList.add('is-busy'); btn.disabled = true; }
    status(root, 'Saving…', true);
    var wasSaved = isSaved(root);
    return updateAttributes(collect(root)).then(function () {
      if (btn) { btn.classList.remove('is-busy'); btn.disabled = false; }
      root._obgstSnapshot = snapshot(root);
      paintSummary(root);
      showSaved(root, true);
      status(root, MESSAGES.saved, true);
      clearBlockedNotice();
      track(wasSaved ? 'gst_invoice_edited' : 'gst_invoice_saved', { gst_same_as_shipping: sameAsShipping(root) });
      return true;
    }, function (err) {
      if (btn) { btn.classList.remove('is-busy'); btn.disabled = false; }
      status(root, err && err.message === 'network' ? MESSAGES.network : MESSAGES.save_failed, false);
      track('gst_invoice_save_failed', { gst_reason: err && err.message === 'network' ? 'network' : 'cart' });
      return false;
    });
  }

  function disable(root) {
    /* the typed values stay on the cart so the shopper can switch it back on */
    showSaved(root, false);
    var form = root.querySelector('[data-obgst-form]');
    if (form) form.hidden = true;
    status(root, '', true);
    track('gst_invoice_disabled');
    return updateAttributes({ gst_invoice_required: 'false' }).then(function () {
      root._obgstSnapshot = null;
      return true;
    }, function () {
      status(root, MESSAGES.save_failed, false);
      return false;
    });
  }

  function openForm(root) {
    var form = root.querySelector('[data-obgst-form]');
    var summary = root.querySelector('[data-obgst-summary]');
    if (form) form.hidden = false;
    if (summary) summary.hidden = true;
    paintGstinStatus(root);
  }

  /* ---------------- checkout guard ---------------- */
  var CHECKOUT_SELECTOR = '.gokwik-checkout button, #gokwik-buy-now, button[name="checkout"], [data-obgst-checkout]';
  function blockedNotice(root, message) {
    clearBlockedNotice();
    var note = document.createElement('p');
    note.className = 'obgst-blocked';
    note.setAttribute('data-obgst-blocked', '');
    note.setAttribute('role', 'alert');
    note.textContent = message;
    root.appendChild(note);
    if (root.scrollIntoView) root.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
  function clearBlockedNotice() {
    qsa('[data-obgst-blocked]').forEach(function (n) { if (n.parentNode) n.parentNode.removeChild(n); });
  }
  document.addEventListener('click', function (e) {
    if (!readConfig().enabled || !readConfig().require_confirmation_before_checkout) return;
    var btn = e.target && e.target.closest ? e.target.closest(CHECKOUT_SELECTOR) : null;
    if (!btn) return;
    var root = active();
    if (!root || !wantsGst(root)) return;              /* GST off: checkout is untouched */
    if (isSaved(root) && !isDirty(root)) return;       /* saved and unchanged: carry on */
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    openForm(root);
    var problems = validate(root);
    if (problems.length) paintErrors(root, problems);
    blockedNotice(root, problems.length ? problems[0].message : MESSAGES.incomplete);
    track('gst_invoice_checkout_blocked', { gst_reason: problems.length ? 'invalid' : 'unsaved' });
  }, true);

  /* ---------------- wiring ---------------- */
  document.addEventListener('change', function (e) {
    var el = e.target;
    if (!el || !el.closest) return;
    var root = el.closest('[data-obgst]');
    if (!root) return;

    if (el.hasAttribute('data-obgst-toggle')) {
      clearBlockedNotice();
      if (el.checked) {
        openForm(root);
        track('gst_invoice_enabled');
      } else {
        disable(root);
      }
      return;
    }
    if (el.hasAttribute('data-obgst-same')) {
      var box = root.querySelector('[data-obgst-address]');
      var note = root.querySelector('[data-obgst-same-note]');
      if (box) box.hidden = el.checked;
      if (note) note.hidden = !el.checked;
      paintErrors(root, []);
      return;
    }
    if (el.hasAttribute('data-obgst-input')) {
      if (el.getAttribute('data-obgst-input') === 'gstin') paintGstinStatus(root);
    }
  });

  document.addEventListener('input', function (e) {
    var el = e.target;
    if (!el || !el.hasAttribute || !el.hasAttribute('data-obgst-input')) return;
    var root = el.closest('[data-obgst]');
    if (!root) return;
    var name = el.getAttribute('data-obgst-input');
    if (name === 'gstin') {
      var caret = el.selectionStart;
      el.value = el.value.toUpperCase().replace(/[^0-9A-Z]/g, '').slice(0, 15);
      try { el.setSelectionRange(caret, caret); } catch (err) { /* not a text input everywhere */ }
      paintGstinStatus(root);
      /* fill the state from the GSTIN when it is still empty, and never overwrite a choice */
      var state = field(root, 'state');
      var guess = stateFromGstin(el.value);
      if (state && guess && !state.value) state.value = guess;
    }
    if (name === 'pincode') el.value = el.value.replace(/[^0-9]/g, '').slice(0, 6);
    var err = root.querySelector('[data-obgst-err="' + name + '"]');
    if (err && !err.hidden) { err.hidden = true; el.removeAttribute('aria-invalid'); }
  });

  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest ? e.target.closest('[data-obgst-save], [data-obgst-edit]') : null;
    if (!el) return;
    var root = el.closest('[data-obgst]');
    if (!root) return;
    e.preventDefault();
    clearBlockedNotice();
    if (el.hasAttribute('data-obgst-edit')) { openForm(root); return; }
    save(root, el);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var el = e.target;
    if (!el || !el.hasAttribute || !el.hasAttribute('data-obgst-input')) return;
    if (el.tagName === 'TEXTAREA') return;
    var root = el.closest('[data-obgst]');
    if (!root) return;
    e.preventDefault();
    save(root, root.querySelector('[data-obgst-save]'));
  });

  /* the cart re-renders on quantity changes: keep the badge honest without
     touching anything the shopper is in the middle of typing */
  document.addEventListener('cart:update', function () {
    var root = active();
    if (!root) return;
    var form = root.querySelector('[data-obgst-form]');
    if (form && !form.hidden && wantsGst(root)) return;
    fetch(routeRoot() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        root = active();
        if (!root) return;
        var currentForm = root.querySelector('[data-obgst-form]');
        if (currentForm && !currentForm.hidden && wantsGst(root)) return;
        var attrs = (cart && cart.attributes) || {};
        var on = String(attrs.gst_invoice_required) === 'true';
        var toggle = root.querySelector('[data-obgst-toggle]');
        if (toggle) toggle.checked = on;
        showSaved(root, on && !!attrs.gstin);
      })
      .catch(function () { /* the card keeps showing what the page rendered */ });
  });

  function init() {
    readConfig();
    cards().forEach(function (root) {
      var form = root.querySelector('[data-obgst-form]');
      if (form && !wantsGst(root)) form.hidden = true;
      if (root._obgstReady) return;
      root._obgstReady = true;
      if (isSaved(root)) root._obgstSnapshot = snapshot(root);
      paintGstinStatus(root);
      if (!opened) { opened = true; track('gst_invoice_opened'); }
    });
  }

  document.addEventListener('shopify:section:load', init);
  /* Cart events precede section replacement; reconcile newly rendered cards. */
  var cardObserver = new MutationObserver(function (records) {
    var changed = records.some(function (record) {
      return Array.prototype.some.call(record.addedNodes, function (node) {
        return node.nodeType === 1 && (node.matches('[data-obgst]') || node.closest('[data-obgst]') || node.querySelector('[data-obgst]'));
      });
    });
    if (changed) init();
  });
  cardObserver.observe(document.body, { childList: true, subtree: true });
  window.OblivionGST = {
    version: '1.0.0',
    init: init,
    config: function () { return readConfig(); },
    validate: validate,
    gstinProblem: gstinProblem,
    checkCharacter: checkCharacter,
    stateFromGstin: stateFromGstin,
    save: function (btn) { var root = active(); return root ? save(root, btn || null) : Promise.resolve(false); },
    disable: function () { var root = active(); return root ? disable(root) : Promise.resolve(false); }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
